const INITIAL_ALERT_CONTENT = {
    message:  '',
    // The below properties are just for styling purposes.
    // They can be left as false by default, as the component will work normally without them.
    centered: false,
    rounded:  false,
};

// Spread into separate objects to avoid shared reference mutation
export const INITIAL_APPLICATION_ALERTS_STATE = {
    success: { ...INITIAL_ALERT_CONTENT },
    error:   { ...INITIAL_ALERT_CONTENT },
};

export const DEFAULT_STORE_TITLE = 'Loja Virtual | Adquira do conforto da sua casa';
